import { formatTableData, getData } from '../utils/formatters';

interface MapletonData {
  address?: string;
  city?: string;
  zip?: string;
  parcelId?: string;
  parcelSerial?: string;
  ownerName?: string;
  ownerMailingAddress?: string;
  ownershipType?: string;
  acres?: string | number;
  countyParcelUrl?: string;
  zone?: string;
  zoningCode?: string;
  zoningLabel?: string;
  zoningDescription?: string;
  netUnitsPerAcre?: string | number;
  densityNote?: string;
}

const MAPLETON_ROWS = [
  {
    label: 'Address',
    getValue: (data: MapletonData) => getData(data, 'address', 'No address available')
  },
  {
    label: 'City, Zip',
    getValue: (data: MapletonData) =>
      `${getData(data, 'city', 'N/A')}, ${getData(data, 'zip', 'N/A')}`
  },
  {
    label: 'Parcel ID',
    getValue: (data: MapletonData) => getData(data, 'parcelId', 'No parcel ID available')
  },
  {
    label: 'Parcel Serial',
    getValue: (data: MapletonData) =>
      getData(data, 'parcelSerial', 'No parcel serial available')
  },
  {
    label: 'Owner',
    getValue: (data: MapletonData) => getData(data, 'ownerName', 'No owner information available')
  },
  {
    label: 'Owner Mailing Address',
    getValue: (data: MapletonData) =>
      getData(data, 'ownerMailingAddress', 'No owner mailing address available')
  },
  {
    label: 'Ownership Type',
    getValue: (data: MapletonData) =>
      getData(data, 'ownershipType', 'No ownership type available')
  },
  {
    label: 'Property Size',
    getValue: (data: MapletonData) => {
      const acres = data.acres;
      if (acres === undefined || acres === null || acres === '') {
        return 'No property size information available';
      }
      return `${acres} acres`;
    }
  },
  {
    label: 'Zone',
    getValue: (data: MapletonData) => {
      const label = data.zoningLabel || data.zone;
      const code = data.zoningCode;
      if (label) {
        return code && code !== label ? `${label} (${code})` : label;
      }
      if (code) {
        return code;
      }
      return 'No zoning information available';
    }
  },
  {
    label: 'Zoning Description',
    getValue: (data: MapletonData) =>
      getData(data, 'zoningDescription', 'No zoning description available')
  },
  {
    label: 'Net Density',
    getValue: (data: MapletonData) => {
      const units = data.netUnitsPerAcre;
      if (units === undefined || units === null || units === '') {
        return 'No density information available';
      }
      return `${units} unit${Number(units) === 1 ? '' : 's'} per acre`;
    }
  },
  {
    label: 'Density Note',
    getValue: (data: MapletonData) =>
      getData(data, 'densityNote', 'No density note available')
  },
  {
    label: 'County Parcel Record',
    getValue: (data: MapletonData) => {
      if (data.countyParcelUrl) {
        return `[View County Parcel Record](${data.countyParcelUrl})`;
      }
      return 'No county parcel record available';
    }
  }
];

export const formatMapletonData = (data: MapletonData): string => {
  return formatTableData(data, MAPLETON_ROWS);
};
